import { z } from 'zod'
import { NewPassword } from '../password'
import { ChatProviderId, ProviderId, SuggestionMode } from '../enums'
import { Id, Instant, Ratio } from './primitives'
import { OperatorSettings, OperatorTermsInput, TENANT_NAME_MAX_CHARS } from './tenant'

export const OPERATOR_ACTIONS = ['tenant_created', 'tenant_deleted', 'commercial_terms_updated'] as const
export const OperatorAction = z.enum(OPERATOR_ACTIONS)
export type OperatorAction = z.infer<typeof OperatorAction>

export const ADMIN_DISPLAY_NAME_MAX_CHARS = 100

export const AgencyTenant = z.object({
  id: Id,
  name: z.string().min(1),
  suggestionMode: SuggestionMode,
  primaryProvider: ProviderId,
  secondaryProvider: ProviderId.nullable(),
  claimIdleMinutes: z.number().int().positive(),
  answerabilityThreshold: Ratio,
  operatorFields: OperatorSettings,
  createdAt: Instant,
})
export type AgencyTenant = z.infer<typeof AgencyTenant>

export const AgencyTenantList = z.object({ tenants: z.array(AgencyTenant) })
export type AgencyTenantList = z.infer<typeof AgencyTenantList>

export const DeletedAgencyTenant = z.object({ id: Id, deletedAt: Instant })
export type DeletedAgencyTenant = z.infer<typeof DeletedAgencyTenant>

export const CreateTenantRequest = z.strictObject({
  name: z.string().min(1).max(TENANT_NAME_MAX_CHARS),
  primaryProvider: ChatProviderId,
  secondaryProvider: ChatProviderId.nullable().optional(),
  operatorFields: OperatorTermsInput,
  adminEmail: z.email(),
  adminDisplayName: z.string().min(1).max(ADMIN_DISPLAY_NAME_MAX_CHARS).nullable().optional(),
  adminPassword: NewPassword.optional(),
})
export type CreateTenantRequest = z.infer<typeof CreateTenantRequest>

export const CommercialTermsRequest = z.strictObject({
  ...OperatorTermsInput.shape,
  monthlyTokenBudget: OperatorTermsInput.shape.monthlyTokenBudget.optional(),
})
export type CommercialTermsRequest = z.infer<typeof CommercialTermsRequest>
